#!/usr/bin/env node

import { initCommand } from "./commands/init";

const args = process.argv.slice(2);
const command = args[0];

switch (command) {
  case "init":
    initCommand();
    break;

  default:
    console.log("GMM CLI");
}
